export default "__VITE_ASSET__hLjwRgLa__"